export const showContactForm = message => ({
  type: "SHOW_CONTACT_FORM",
  payload: message
});



// WEBPACK FOOTER //
// ./src/actions/index.js